import { TableWithDropdown } from './TableWithDropdown';
export default TableWithDropdown;